'use client';

import React from 'react';
import { FiLink } from 'react-icons/fi';

import config from 'configs/app';

import styles from './NetworkAddToWallet.module.css';

const NetworkAddToWallet = () => {
  const [ account, setAccount ] = React.useState<string | null>(null);

  React.useEffect(() => {
    const ethereum = (window as any).ethereum;
    if (!ethereum) return;

    ethereum.request({ method: 'eth_accounts' })
      .then((accounts: string[]) => {
        if (accounts.length > 0) setAccount(accounts[0]);
      })
      .catch(() => {});

    const handleAccountsChanged = (accounts: string[]) => {
      setAccount(accounts.length > 0 ? accounts[0] : null);
    };
    ethereum.on('accountsChanged', handleAccountsChanged);
    return () => ethereum.removeListener('accountsChanged', handleAccountsChanged);
  }, []);

  const handleAddNetwork = React.useCallback(async() => {
    const ethereum = (window as any).ethereum;

    if (!ethereum) {
      window.open('https://metamask.io/download/', '_blank');
      return;
    }

    const hexChainId = '0x' + Number(config.chain.id).toString(16);

    try {
      await ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: hexChainId }],
      });
    } catch (error: any) {
      if (error?.code === 4902 || error?.data?.originalError?.code === 4902) {
        try {
          await ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: hexChainId,
              chainName: config.chain.name,
              nativeCurrency: {
                name: config.chain.currency.name,
                symbol: config.chain.currency.symbol,
                decimals: config.chain.currency.decimals,
              },
              rpcUrls: config.chain.rpcUrls,
              blockExplorerUrls: [config.app.baseUrl],
            }],
          });
        } catch {
          // user rejected
        }
      }
    }
  }, []);

  const handleConnect = React.useCallback(async() => {
    const ethereum = (window as any).ethereum;

    if (!ethereum) {
      window.open('https://metamask.io/download/', '_blank');
      return;
    }

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      if (accounts.length > 0) {
        setAccount(accounts[0]);
      }
    } catch {
      // user rejected
    }
  }, []);

  const truncateAddress = (addr: string) => `${addr.slice(0, 6)}...${addr.slice(-4)}`;

  return (
    <div className={ styles.wrapper }>
      <button className={ styles.button } onClick={ handleAddNetwork }>
        <img src="https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg" alt="MetaMask" width={ 20 } height={ 20 } />
        Add OpenGPU Mainnet
      </button>
      <button className={ styles.buttonPrimary } onClick={ handleConnect }>
        <FiLink size={ 16 } />
        { account ? truncateAddress(account) : 'Connect Wallet' }
      </button>
    </div>
  );
};

export default React.memo(NetworkAddToWallet);
